import { getUserInfo } from '@/api/loginApi'
import router from '@/router'
import { ElMessage } from 'element-plus'

const state = {
  token: '',
  name: '',
  avatar: '',
  introduction: '',
  userId: '',
  roles: [],
  isSuperAdmin: 0
}
const mutations = {
  SET_INTRODUCTION: (state: { introduction: any }, introduction: any) => {
    state.introduction = introduction
  },
  SET_NAME: (state: { name: any }, name: any) => {
    state.name = name
  },
  SET_AVATAR: (state: { avatar: any }, avatar: any) => {
    state.avatar = avatar
  },
  SET_ROLES: (state: { roles: any }, roles: any) => {
    state.roles = roles
  },
  SET_USERUID: (state: any, userId: any) => {
    state.userId = userId
  },
  SET_ISSUPERADMIN: (state: any, isSuperAdmin: any) => {
    state.isSuperAdmin = isSuperAdmin
  }
}
const actions = {
  // get user info
  getInfo({ commit }: any) {
    return new Promise((resolve, reject) => {
      getUserInfo().then((response: { data: any }) => {
        const { data } = response
        console.log(data)
        if (!data) {
          ElMessage({
            message: '认证失败,请重新登录',
            type: 'error'
          })
          reject(new Error('认证失败，请重新登录'))
          localStorage.clear()
        }
        // 从后端返回的data数据中解构出用户相关的信息
        const { roles, name, avatar, introduction, id, isSuperAdmin } = data
        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          localStorage.clear()
          ElMessage({
            message: '该用户未分配权限！请分配完成在重新登录',
            type: 'error'
          })
          reject(new Error('该用户未分配权限！请分配完成在重新登录'))
          router.replace('/login')
          return
        }
        commit('SET_ROLES', roles)
        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        commit('SET_INTRODUCTION', introduction)
        // 用户ID
        commit('SET_USERUID', id)
        commit('SET_ISSUPERADMIN', isSuperAdmin)
        // 将权限字段保存到sessionStorage中
        sessionStorage.setItem('codeList', JSON.stringify(roles))
        resolve(data)
      }).catch((error: any) => {
        reject(error)
      })
    })
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
